export * from './lib/stable-dialog.module';

export * from './lib/stable-dialog.component';
